import React, { useState, useEffect } from "react"
import PdpInit from '~/initializers/pdp-init'
import { PdpProvider } from '~/contexts/PdpContext'
import { jnstyls, notBlank, imgSize } from '~/utils/helpers'

import BlogPdpDetails from '~/components/testing/blog-pdp-details'

import * as styles from "~/styles/testing/blog-pdp.module.scss"

const BlogPdp = ({teston, setTeston}) => {
  const { setupProduct, setupVariants } = PdpInit()

  const [data, setData] = useState(null)
  const [variants, setVariants] = useState(null)

  const getProdJson = async (handle) => {
    const response = await fetch(`/page-data/products/${handle}/page-data.json`)
    const json = await response.json()
    const prod_data = json?.result?.data?.product
    if (!prod_data) return

    prod_data.variants.forEach(x => x.inv = {})
    prod_data.pl_colors = prod_data.product_line

    const productData = setupProduct(prod_data)
    const variantData = setupVariants({variants: prod_data.variants, isGift: prod_data.is_gift})
    setVariants(variantData)
    setData(productData)
  }

  useEffect(() => {
    if (!teston) return
    getProdJson('sand-dune-draped-linen-deuce-coupe-camp-shirt')

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [teston])


  return data ? (
    <PdpProvider productData={data} variantData={data.variants} isSearch={true}>
      <BlogPdpDetails setTeston={setTeston} setData={setData} />
    </PdpProvider>
  ) : teston ? (
    <div className={styles.loading}>Loading...</div>
  ) : (
    <button className={styles.cta} onClick={(e)=>setTeston(true)}>
      That shirt is sweet, right? Buy that Shit!
    </button>
  )
}


export default BlogPdp